import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import RedemptionsList from './redemptions-list'
import RedemptionSearch from './redemption-search'
import { getRewardRedemptions } from '../../../../actions/staff'
import PageTitle from '../../../common/page-title/index'

import './styles.css'

class StaffRewardRedemptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keywords: '',
      autoredemption: '',
      dateFrom: '',
      dateTo: '',
      pageNumber: 1
    };
  }

  componentWillMount() {
    this.props.dispatch(getRewardRedemptions());
  }

  handleInputChange = (e) => {
    this.setState({keywords: e.target.value});
  };

  handleDateFromChange = (value) => {
    if(typeof value === 'object'){
      this.setState({dateFrom: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateFrom: ''});
    }
  };

  handleDateToChange = (value) => {
    if(typeof value === 'object'){
      this.setState({dateTo: value.format('DD/MM/YYYY')});
    } else {
      this.setState({dateTo: ''});
    }
  };

  handleAutoredemptionChange = (e) => {
    this.setState({autoredemption: e.target.value});
  };

  handleSearch = () => {
    const {keywords, dateFrom, dateTo, autoredemption} = this.state;
    this.props.dispatch(getRewardRedemptions(keywords, dateFrom, dateTo, autoredemption)).then(() => {
      this.setState({
        pageNumber: 1
      });
    });
  };

  handleClear = () => {
    this.setState({
      keywords: '',
      dateFrom: '',
      dateTo: '',
      autoredemption: '',
      pageNumber: 1
    }, this.handleSearch);
  };

  handlePageChange = (page, size) => {
    this.setState({pageNumber:  page}, this.afterPageChange);
  };

  afterPageChange = () => {
    const {keywords, dateFrom, dateTo, autoredemption, pageNumber} = this.state;
    this.props.dispatch(getRewardRedemptions(keywords, dateFrom, dateTo, autoredemption, pageNumber))
  };

  render() {
    return (
      <Grid bsClass="container" fluid className="staff-reward-redemptions">
        <PageTitle>STAFF REWARD REDEMPTIONS</PageTitle>

        <Row>
          <Col md={12}>
            <RedemptionSearch
              searchValue={this.state.keywords}
              dateFromValue={this.state.dateFrom}
              dateToValue={this.state.dateTo}
              autoredemptionValue={this.state.autoredemption}
              onInputChange={this.handleInputChange}
              onDateFromChange={this.handleDateFromChange}
              onDateToChange={this.handleDateToChange}
              onAutoredemptionChange={this.handleAutoredemptionChange}
              onSearch={this.handleSearch}
              onClear={this.handleClear}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <RedemptionsList
              redemptions={this.props.redemptions}
              fetching={this.props.fetching}
              fetched={this.props.fetched}
              paging={this.props.paging}
              onPageChange={this.handlePageChange}
              currentPage={this.state.pageNumber}
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    redemptions: state.staff.redemptions.list,
    links: state.staff.redemptions.links,
    fetching: state.staff.fetching,
    fetched: state.staff.fetched,
    paging: state.staff.redemptions.paging
  };
};

export default connect(mapStateToProps)(StaffRewardRedemptions);


// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/redemptions/index.jsx